import React, { createContext, useMemo, useState } from 'react'

const InitialPageValue = {
  currentPage: '',
  kpiClicked:false,
  previousPage: '',
  setCurrentPage: (s?: any) => {
    console.error('stub', s)
  },
  setKPIClicked: (s?: any) => {
    console.error('stub', s)
  },
  setPreviousPage: (s?: any) => {
    console.error('stub', s)
  },
}

const PreviousPageContext = createContext(InitialPageValue)

const PreviousPageProvider: React.FC = ({ children }) => {
  const [currentPage, setCurrentPage] = useState<string>('')
  const [previousPage, setPreviousPage] = useState<string>('')
  const [kpiClicked, setKPIClicked] = useState<boolean>(false)

  const value = useMemo(
    () => ({
      currentPage,
      kpiClicked,
      previousPage,
      setCurrentPage,
      setKPIClicked,
      setPreviousPage,
    }),
    [currentPage, setCurrentPage, setPreviousPage, previousPage, kpiClicked, setKPIClicked]
  )

  return <PreviousPageContext.Provider value={value}>{children}</PreviousPageContext.Provider>
}

export { InitialPageValue, PreviousPageContext, PreviousPageProvider }
